import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store.js";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      alias: "/home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/search",
      name: "search",
      component: () =>
        import(/* webpackChunkName: "search" */ "./views/Search.vue"),
      meta: {
        requiresAuth: true,
        hideCategoryDrawer: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
      meta: {}
    },
    {
      path: "/contact",
      name: "contact",

      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue"),
      meta: {
        hideCategoryDrawer: true,
        hideEventDrawer: true
      }
    },
    {
      path: "/forgot",
      name: "forgot",
      component: () =>
        import(/* webpackChunkName: "forgot" */ "./views/Forgot.vue"),
      meta: {}
    },
    {
      path: "/reset",
      name: "reset",
      component: () =>
        import(/* webpackChunkName: "reset" */ "./views/Reset.vue"),
      meta: {}
    },
    {
      path: "/register",
      name: "register",

      component: () =>
        import(/* webpackChunkName: "register" */ "./views/Register.vue"),
      meta: {}
    },
    {
      path: "/registration",
      redirect: { name: "register" }
    },
    {
      path: "/success",
      name: "success",
      component: () =>
        import(/* webpackChunkName: "success" */ "./views/Success.vue"),
      meta: {}
    },
    // {
    //   path: "/sandbox",
    //   name: "sandbox",
    //   component: () =>
    //     import(/* webpackChunkName: "sandbox" */ "./views/Sandbox.vue"),
    //   meta: {}
    // },
    {
      path: "/404",
      name: "error",
      component: () =>
        import(/* webpackChunkName: "error" */ "./views/404.vue"),
      meta: {}
    },
    {
      path: "*",
      redirect: { name: "error" }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  let jwt = localStorage.getItem("jwt");
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn && jwt) {
      next();
      return;
    }
    store.dispatch("logout").then(router.push("/login"));
    next("/login");
  } else {
    next();
  }
});

export default router;
